// Anti shoulder-surfing: digits move, so watching the hand does not give the PIN
const DIGITS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

// back and clear stay put: moving a correction key causes mistakes, and it leaks nothing
const LAYOUT = [
  'digit', 'digit', 'digit',
  'digit', 'digit', 'digit',
  'digit', 'digit', 'digit',
  'back', 'digit', 'clear',
];

const NATURAL = DIGITS.join('');

function fisherYates(list) {
  const out = [...list];
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}

// A shuffle that lands on 1234567890 would defeat the point, so it is redrawn
export function shuffledKeypad() {
  let digits = fisherYates(DIGITS);
  let guard = 0;
  while (digits.join('') === NATURAL && guard < 10) {
    digits = fisherYates(DIGITS);
    guard += 1;
  }

  let next = 0;
  return LAYOUT.map((slot) => (slot === 'digit' ? digits[next++] : slot));
}

export default shuffledKeypad;
